import { useEffect, useState } from 'react';
import axios from 'axios';
import BreadcrumbList from '@root/modules/Sellers/Stock/components/Breadcrumb';
import { Table } from 'antd';
const ApiImport = () => {
  const breadcrumbList = [
    {
      tittle: '외부 api 송출 내역',
      url: ''
    },
    {
      tittle: '외부 api 송출 내역 조회',
      url: ''
    }
  ];
  const [apiList, setApiList] = useState([]);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  useEffect(() => {
    const fetchApiList = async () => {
      const res = await axios.get(
        `https://public-api.buskfulfillment.com/api/v1/histories?page=${page}`
      );
      setApiList(res.data.data);
      setTotal(res.data.lastPage);
    };
    fetchApiList();
  }, [page]);
  console.log(apiList);
  const columns = [
    {
      title: 'ID',
      dataIndex: 'id'
    },
    {
      title: 'Title',
      dataIndex: 'title'
    },
    {
      title: 'Description',
      dataIndex: 'description'
    },
    {
      title: 'Api Type',
      dataIndex: 'apiType'
    },
    {
      title: 'Domain',
      dataIndex: 'domain'
    },
    {
      title: 'Request Type',
      dataIndex: 'requestType'
    },
    {
      title: 'Status',
      dataIndex: 'status'
    },
    {
      title: '송출일',
      dataIndex: 'createdAt'
    }
  ];
  return (
    <div>
      <BreadcrumbList listBreadcrumb={breadcrumbList} />
      <div className="busk-container">
        <Table
          pagination={{
            total: total,
            current: page + 1,
            pageSize: 10,
            onChange: (page, pageSize) => {
              setPage(page);
            }
          }}
          dataSource={apiList}
          columns={columns}
        />
      </div>
    </div>
  );
};

export default ApiImport;
